import { configureStore } from "@reduxjs/toolkit";
import billSlice from "../components/bills/billSlice";
import outBillSlice from "../components/bills/outbillSlice";
// import { pokemonApi } from "../components/bills/querySlice";
import detailsSlice from "../components/fast cash/detailsSlice";
import fastCashSlice from "../components/fast cash/fastCashSlice";
import itemsSlice from "../components/inventory/itemsSlice";
import ledgerSlice from "../components/ledgers/ledgerSlice";
import billnumSlice from "../components/point of sale/billnumSlice";
import saleSlice from "../components/point of sale/saleSlice";
import warenumSlice from "../components/point of sale/warenumSlice";

import unitReducer from "../components/units/unitSlice";
import vendorSlice from "../components/vendors/vendorSlice";

import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore, FLUSH, REHYDRATE } from "redux-persist";
import { PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import categorySlice from "../components/daybook/categorySlice";
import dashboardSlice from "../components/adminDashboard/dashboardSlice";
import invoiceSlice from "../components/invoice/invoiceSlice";
import purchaseSlice from "../components/purchaseOrders/purchaseSlice";
import saleReturnSlice from "../components/saleReturn/saleReturnSlice";
import companySlice from "../components/company profile/companySlice";
import vehicleSlice from "../components/vehicles/vehicleSlice";
import vehicleReportSlice from "../components/vehicles/vehicleReportSlice";
import ledgersNamesSlice from "../components/ledgers/ledgersNamesSlice";
import employeesSlice from "../components/company profile/employeesSlice";
import ledgerDetailSlice from "../components/ledgers/detailSlice";
import balanceSheetSlice from "../components/reports/tables/balanceSheetSlice";
import trialSlice from "../pages/trial/trialSlice";
import transactionSlice from "../components/daybook/transactionSlice";
import userSlice from "../pages/userSlice";

const persistConfig = {
  key: "root",
  storage,
};

const persistCompanyConfig = {
  key: "company",
  storage,
};

const persistConfigInventory = {
  key: "inventory",
  storage,
  // whitelist: ['status', 'expiryDate'],
};

const persistedReducer = persistReducer(persistConfig, saleSlice);
const transactionPersisted = persistReducer(persistConfig, transactionSlice);
const inventoryPersisted = persistReducer(persistConfigInventory, itemsSlice);
const trialPersisted = persistReducer(persistConfig, trialSlice);
const companyPersisted = persistReducer(persistCompanyConfig, companySlice);
const userPersisted = persistReducer(persistConfig, userSlice);

export const store = configureStore({
  reducer: {
    prReducer: persistedReducer,
    units: unitReducer,
    vendor: vendorSlice,
    sale: persistedReducer,
    fastCash: fastCashSlice,
    fastCashDetail: detailsSlice,
    inventory: itemsSlice,
    ledger: ledgerSlice,
    billNum: billnumSlice,
    wareNum: warenumSlice,
    bill: billSlice,
    outBill: outBillSlice,
    daybookCat: categorySlice,
    dashboardData: dashboardSlice,
    invoice: invoiceSlice,
    purchase: purchaseSlice,
    saleReturn: saleReturnSlice,
    company: companyPersisted,
    vehicle: vehicleSlice,
    vehicleReport: vehicleReportSlice,
    ledgersNames: ledgersNamesSlice,
    employee: employeesSlice,
    ledgerDetail: ledgerDetailSlice,
    balanceSheet: balanceSheetSlice,
    trial: trialPersisted,
    transaction: transactionPersisted,
    user: userPersisted,
    // middleware: [thunk],
    // [pokemonApi.reducerPath]: pokemonApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
